module.exports = __webpack_public_path__ + "static/media/habba-habba-ad4.4238b552.jpeg";